var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "process-model" },
    _vm._l(_vm.models, function (model, key) {
      return _c("li", { class: _vm.getIconClass(key) }, [
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                return _vm.changeStage(key)
              },
            },
          },
          [
            _c(
              "div",
              {
                class: {
                  "active-wrap": _vm.stage === key,
                  "visited-wrap": _vm.stage !== key && key < _vm.maxStage,
                },
              },
              [_c("i", { class: model.icon, attrs: { "aria-hidden": "true" } })]
            ),
            _vm._v(" "),
            _c("p", {
              staticClass: "no-margin",
              domProps: { innerHTML: _vm._s(model.title) },
            }),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }